import React from 'react'
import { Theme, useTheme } from '@mui/material'

interface IIconProps {
  width?: string
}

const BestTournamentIcon: React.FC<IIconProps> = (props) => {
  const theme: Theme = useTheme()
  return (
    <svg
      id='Capa_1' enableBackground='new 0 0 512.004 512.004' height={props.width} fill={theme.palette.text.primary}
      viewBox='0 0 512.004 512.004' width={props.width} xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='m381.361 452.004h-250.717c-8.284 0-15 6.716-15 15v30c0 8.284 6.716 15 15 15h250.717c8.284 0 15-6.716 15-15v-30c0-8.284-6.716-15-15-15z'
      />
      <path
        d='m314.764 379.14h-10.587c-3.354-8.977-5.68-23.612-5.89-42.569-13.255 3.469-27.406 5.228-42.399 5.228-13.081 0-27.383-1.382-41.99-5.163-.045 8.862-.558 18.645-2.041 27.688-.839 5.115-2.119 10.421-3.803 14.815h-10.814c-19.299 0-35 15.701-35 35v7.864h187.523v-7.864c.001-19.298-15.7-34.999-34.999-34.999z'
      />
      <path
        d='m486.909 60.267h-53.331c-.646 7.185-1.21 14.557-1.621 19.943-.249 3.262-.507 6.624-.776 10.057h40.173c-3.358 41.122-21.991 76.861-55.535 106.624-3.236 12.803-7.158 25.45-11.979 37.6-1.887 4.757-3.891 9.349-5.991 13.801l17.996-13.028c57.107-41.342 86.064-94.755 86.064-158.755v-1.243c0-8.284-6.716-14.999-15-14.999z'
      />
      <path
        d='m95.07 196.001c-32.87-29.6-51.129-65.041-54.429-105.735h39.032c-.34-4.349-.658-8.577-.965-12.663-.371-4.937-.84-11.166-1.369-17.337h-52.243c-8.284 0-15 6.716-15 15v1.352c0 63.921 28.905 117.297 85.913 158.646l17.221 12.49c-2.215-4.693-4.346-9.598-6.375-14.748-4.724-11.987-8.585-24.426-11.785-37.005z'
      />
      <path
        d='m89.727 30h14.014c2.158 9.113 3.646 28.914 4.882 45.355 3.147 41.878 7.457 99.232 26.142 146.654 23.475 59.58 64.227 89.79 121.122 89.79 56.407 0 96.803-29.733 120.066-88.372 18.549-46.753 22.907-103.828 26.089-145.503 1.339-17.534 2.958-38.723 5.395-47.926h14.839c8.284 0 15-6.716 15-15s-6.716-15-15-15h-332.549c-8.284 0-15 6.716-15 15 0 8.286 6.716 15.002 15 15.002zm142.035 76.642 21.12-12.8c1.28-.8 2.88-1.12 4.641-1.12 5.12 0 11.04 3.04 11.04 7.84v101.762c0 5.12-6.24 7.68-12.48 7.68s-12.481-2.56-12.481-7.68v-81.442l-4.64 2.88c-1.44.96-2.88 1.28-4 1.28-4.641 0-7.841-4.96-7.841-9.92 0-3.36 1.441-6.56 4.641-8.48z'
      />
    </svg>
  )
}
export default BestTournamentIcon
